import ClearIcon from "@mui/icons-material/Clear";
import Notifications from "@mui/icons-material/Notifications";
import {
  Badge,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Popover,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

function NotificationWithAlerts({ alerts, setAlerts }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearById = (id) => {
    setAlerts(alerts.filter((a) => a.alert_id !== id));
  };

  const handleClearAll = () => {
    setAlerts([]);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? 'notification-popover' : undefined;

  return (
    <>
      <IconButton color="primary" sx={{ marginRight: '10px' }} onClick={handleClick}>
        <Badge badgeContent={alerts.length} color="error">
          <Notifications />
        </Badge>
      </IconButton>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box sx={{ width: '25vw' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              px: 2,
              mt: 1,
            }}
          >
            <Typography variant="h6" component="h2">
              Alerts
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="outlined"
                sx={{
                  textTransform: 'none',
                  borderRadius: '2rem',
                  color: '#3C4FB9',
                  backgroundColor: '#C4CAF1',
                  borderColor: 'transparent',
                }}
                onClick={() => undefined}
              >
                See All
              </Button>
              <Button sx={{ textTransform: 'none' }} onClick={handleClearAll}>
                Clear All
              </Button>
            </Box>
          </Box>
          <List sx={{ py: 0 }}>
            {alerts.map((alert, index) => (
              <ListItem
                key={alert.alert_id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 0,
                  bgcolor: index < 3 ? '#EFFBFA' : 'transparent',
                  pl: index < 3 ? '1rem' : '2rem',
                }}
              >
                {index < 3 && (
                  <ListItemIcon sx={{ color: '#30AAA2', minWidth: 'auto', mr: '4px' }}>
                    {' '}
                    <span style={{ fontSize: '2rem', lineHeight: 0.5 }}>•</span>
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={alert.actual_message}
                  // secondary={`${alert.hoursAgo} ago by ${alert.author}`}
                  secondary={`4hr ago by ${alert.created_by}`}
                  sx={{ marginLeft: index < 3 ? '4px' : '0' }}
                />
                <ListItemSecondaryAction>
                  <IconButton onClick={() => clearById(alert.alert_id)} edge="end" aria-label="delete">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>
      </Popover>
    </>
  )
}

export default NotificationWithAlerts;
